import { configureStore } from '@reduxjs/toolkit';
import toastReducer from './slices/toastSlice';
import toastConfigReducer from './slices/toastConfigSlice';
import toastMiddleware from './middleware/toastMiddleware';

export const store = configureStore({
  reducer: {
    toast: toastReducer,
    toastConfig: toastConfigReducer,
    // Add other reducers here as your application grows
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(toastMiddleware),
});

export default store;
